import React from 'react';
import {
  Animated,
  Image,
  Keyboard,
  Platform,
  StyleSheet,
  TouchableOpacity,
  View,
} from 'react-native';
import { AUTH_ROUTES, CONTAINER_MODAL_ROUTES } from '@/navigators/routes';
import { Header, StackHeaderProps } from '@react-navigation/stack';
import { OldWebLink } from './old-web-link';
import { partnerSupplier } from '@/utils/environment';
import { SCREEN_PADDING } from '@/styles';
import { useAuthStackContext } from '@/contexts/auth-stack-context';
import { useLayoutContext } from '@/contexts/layout-context';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useTheme } from '@/contexts/theme-context';

export const AuthStackHeader: React.FC<StackHeaderProps> = (props) => {
  const { headerHeight } = useAuthStackContext();
  const { top } = useSafeAreaInsets();
  const { isSmallLayout } = useLayoutContext();
  const theme = useTheme();

  const logoUrl = theme.images.welcomeLogoUrl;
  const isSignInRoute =
    props.route.name === AUTH_ROUTES.SignIn ||
    props.route.name === AUTH_ROUTES.SignInCode;
  const oldWebLink = partnerSupplier.oldWebLink;
  return (
    <Animated.View
      style={[
        {
          backgroundColor: logoUrl
            ? theme.colors.authBackground
            : theme.colors.transparent,
          height: headerHeight,
          paddingTop: top,
        },
        isSignInRoute ? null : styles.disabledHeader,
      ]}
    >
      <View onTouchStart={Keyboard.dismiss} style={styles.headerContainer}>
        <Header {...props} />
        {!isSmallLayout && Platform.OS === 'web' && oldWebLink ? (
          <OldWebLink style={styles.oldWebLink} url={oldWebLink} />
        ) : null}
      </View>
      {isSignInRoute && logoUrl ? (
        <TouchableOpacity
          disabled={!partnerSupplier.demoEnabled}
          onPress={() => {
            props.navigation.navigate(CONTAINER_MODAL_ROUTES.DemoSettings);
          }}
          style={styles.logoContainer}
          testID="supplier-logo"
        >
          <Image
            alt=""
            resizeMode="contain"
            source={{ uri: logoUrl }}
            style={styles.logoImage}
          />
        </TouchableOpacity>
      ) : null}
    </Animated.View>
  );
};

const styles = StyleSheet.create({
  disabledHeader: {
    display: 'none',
  },
  headerContainer: {
    left: 0,
    position: 'absolute',
    right: 0,
    top: 0,
  },
  logoContainer: {
    alignSelf: 'center',
    height: '100%',
    marginHorizontal: 'auto',
    maxWidth: 200,
    paddingVertical: 12,
    width: '100%',
  },
  logoImage: {
    height: '100%',
    width: '100%',
  },
  oldWebLink: {
    position: 'absolute',
    right: SCREEN_PADDING,
    top: SCREEN_PADDING,
  },
});
